import { State } from "../core/src/states/State";
import MessagePopup from "../core/src/ui/popups/MessagePopup";
import Locale from "../core/src/utils/Locale";
import ViewManager from "../core/src/utils/ViewManager";
import { DefaultLayers } from "../core/src/utils/Layers";
import SceneView from "../core/src/views/SceneView";
import PointerEvents from "../core/src/const/PointerEvents";
import UIController from "../core/src/ui/UIController";
import { UIStates } from "../core/src/ui/UIStates";

export default class EEEnterRecoverState extends State {
    protected scene:SceneView;
    enter() {
        super.enter();
        UIController.setState(UIStates.IDLE);
        this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene('message_box');
        ViewManager.getLayer("SplashOverlay").setScene('open');
        UIController.setState(UIStates.SPIN);
        // message.show(()=>this.exit());
        this.scene.sceneTextFields.get('title').text = ""
        this.scene.sceneTextFields.get('text').text = Locale.getString("gui_incomplete_game");
        this.scene.buttons.get("exit").on(PointerEvents.DOWN,()=>{
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            ViewManager.getLayer("SplashOverlay").clear();
            this.exit()
        });
        // message.setTitle("")
    }
}